import Vue from 'vue'
import { apiBasicThirdApiWxConfig } from './api'
// import { devOrProd } from './utils'
// import { globalModel } from './model'
import { uniq, Wechat } from 'vtils'

Vue.config.ignoredElements = ['wx-open-launch-app', 'wx-open-launch-weapp']

export const wechat = new Wechat()

declare global {
  interface Window {
    wechat: typeof wechat
  }
}

window.wechat = wechat

// if (globalModel.state.inWechatWebView) {
apiBasicThirdApiWxConfig(
  {
    url: location.href.split('#')[0],
  },
  {
    noEncrypt: true,
    noErrorToast: true,
  },
).then(res => {
  console.log(res)
  wechat.config({
    ...(res as any),
    debug: location.href.includes('isWechatDebug=true'),
    autoLoadJSSDK: 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js',
    jsApiList: uniq([...(res.jsApiList || []), 'openLocation']),
    openTagList: uniq([...(res.openTagList || []), 'wx-open-launch-weapp']),
  })
})
// }
